import { useEffect, useState } from 'react';
import { SmartFormEmbed } from '@amo/core/components/containers';
import { getTranslation } from '@amo/core/utils/index.js';
import fingers from '@amo/core/assets/images/icons/fingers.png';
import { getStepBySlug } from '../../../../../utils/function';

const Paiement = (props) => {
    const {
        goTo,
        postPaySubmit,
        goToValidation,
        vehicule,
        analyticsSetEvent,
        payEmbeddedData,
        payLoaded,
    } = props;

    const [smartFormError, setSmartFormError] = useState(null);

    useEffect(() => {
        if (!payEmbeddedData && !payLoaded) {
            analyticsSetEvent({ event: 'quoteConfirmation' });
            postPaySubmit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (payEmbeddedData) {
        return (
            <div id={'etape-paiement'} className={'container my-5'}>
                <div className={'row justify-content-center'}>
                    <div className={'col-lg-8 col-md-10 col-12'}>
                        <h2 className={'mb-4 text-center fw-bold'}>{getTranslation('payment.subscribeWaintingPayment')}</h2>
                        <p className={'text-center mb-4'}>
                            {getTranslation('payment.finalizeSubscription')}{' '}
                            <b>{vehicule.brand?.name} {vehicule.cylindree}</b>
                        </p>

                        {/* Krypton affiche ses propres erreurs de validation
                            (CLIENT_xxx) en interne — pas besoin de doublon
                            React. On garde quand même onError pour pouvoir
                            tracker côté analytics ou afficher un fallback
                            si jamais on en a besoin plus tard. */}
                        <SmartFormEmbed
                            formToken={payEmbeddedData.formToken}
                            publicKey={payEmbeddedData.publicKey}
                            endpoint={payEmbeddedData.endpoint}
                            onPaid={goToValidation}
                            onError={setSmartFormError}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id={'etape-cancel'}>
            <div className={'row justify-content-center align-items-center mt-5'}>
                <div className={'col-lg-3 col-md-6 col-sm-16 col-12 my-2'}>
                    <img src={fingers} alt="" aria-hidden="true" loading="lazy"/>
                </div>
                <div className={'col-lg-7 col-md-6 col-sm-16 col-12 my-2 text-start text-dark'}>
                    <h2 className={'my-4 f-30 fw-bold'}>{getTranslation('payment.subscribeWaintingPayment')}</h2>
                    <p className={'f-14 mb-5'}>
                        {getTranslation('payment.finalizeSubscription')}{' '}
                        <b>{vehicule.brand?.name} {vehicule.cylindree}</b>
                    </p>

                    <button
                        className={`btn btn-secondary btn-smaller btn-arrow mb-2`}
                        onClick={() => goTo({ step: getStepBySlug('recapitulatif'), question: 0 })}
                    >
                        {getTranslation('payment.backToRecap')}
                    </button>
                    <button
                        className={`btn btn-primary btn-smaller btn-arrow ms-4`}
                        onClick={postPaySubmit}
                        disabled={payLoaded}
                    >
                        {getTranslation('payment.iGoToFinalize')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Paiement;
